module.exports = __webpack_public_path__ + "img/no_stops.66b70fed.svg";